import { render, staticRenderFns } from "./RateCreate.vue?vue&type=template&id=23dc3a90&scoped=true&"
import script from "./RateCreate.vue?vue&type=script&lang=js&"
export * from "./RateCreate.vue?vue&type=script&lang=js&"
import style0 from "./RateCreate.vue?vue&type=style&index=0&id=23dc3a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc3a90",
  null
  
)

export default component.exports